import { RequestBuilder, fetchAndRetryIfServerBusy } from '@cvent/nucleus-networking';
import { SESSION_HEADER_EVENT_ID } from '../constants/Request';
import { ServiceError } from '../utils/errors';

/**
 * API client for User Text
 */
export default class TranslationSnapshotClient {
  constructor(baseUrl, eventId, environment, authorizationToken, filterAccountTranslation) {
    this.baseUrl = `${baseUrl}snapshot/translation/${eventId}/`;
    this.environment = environment;
    this.eventId = eventId;
    this.filterAccountTranslation = filterAccountTranslation;
    this.requestBuilder = resource => new RequestBuilder({
      url: this.baseUrl + resource
    })
      .auth(authorizationToken)
      .withCookies()
      .header(SESSION_HEADER_EVENT_ID, eventId)
      .withNoCache();
  }

  /**
   * Get account translations from snapshot for the locale
   */
  getAccountTranslations = async (locale) => {
    const request = this.requestBuilder(`account/locale/${locale}`)
      .query('environment', this.environment)
      .query('filterAccountTranslation', this.filterAccountTranslation)
      .get()
      .json()
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      throw await ServiceError.create('get account translation failed', response, request);
    }
    const getTranslations = await response.json();
    return getTranslations;
  };

  /**
   * Get event translations from snapshot for the locale
   */
  getEventTranslations = async (locale) => {
    const request = this.requestBuilder(`event/locale/${locale}`)
      .query('environment', this.environment)
      .get()
      .json()
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      throw await ServiceError.create('get event translation snapshot failed', response, request);
    }
    const getTranslations = await response.json();
    return getTranslations;
  };
}
